function FarmersChillies() {
    return (
        <div>
            <h2>Farmers Chillies</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default FarmersChillies;